const memberStatuses = Object.freeze({
    active: 0,
    invalid: 1,
    pending: 2,
});

export default memberStatuses;
